export default __webpack_public_path__ + "static/media/coding.19b576dc.png";